export default __webpack_public_path__ + "static/media/wuhannongshang.89915d0a.png";